/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/secret';
import store from '@/store';
import { SECRET } from '@/store/types';
import { UpdateObjectInfo } from '@/utils/util';
import postModule, { StoreSecretCommentPostState } from './post';
import filterModule, { StoreSecretCommentFilterState } from './filter';

export interface StoreSecretCommentState {
  scrolls: Record<number | string, number>;
  // modules
  post: StoreSecretCommentPostState;
  filter: StoreSecretCommentFilterState;
}

export default {
  namespaced: true,
  modules: {
    post: postModule,
    filter: filterModule,
  },
  state: {
    scrolls: {},
  },
  getters: {},
  actions: {
    [SECRET.COMMENT_CHANGE_RELATIONS](_, { id, body }) {
      return new Promise((resolve, reject) => {
        api.changeCommentRelations(id, body).then((res) => {
          if (body.praise !== void 0 || body.point !== void 0) {
            const updateInfo: UpdateObjectInfo = {
              assign: {
                numReward: 0,
              },
            };
            if (updateInfo.assign) {
              if (body.praise !== void 0) {
                updateInfo.assign.isPraised = body.praise;
              }
              if (res.data.numReward) {
                updateInfo.assign.numReward = res.data.numReward;
                updateInfo.assign.tips = `获得悬赏积分 +${res.data.numReward}`;
              }
              if (res.data.num || res.data.num === 0) {
                updateInfo.assign.numPraise = res.data.num;
              }
            }
            store.commit(`secret/comment/post/${SECRET.COMMENT_UPDATE}`, { id, updateInfo });
          }
          resolve(res);
        }).catch(reject);
      });
    },
    [SECRET.COMMENT_DEL_REQUEST]({ commit, state }, { id, extra }) {
      if (id && !state.lock) {
        commit(SECRET.COMMENT_DEL_REQUEST);
        return new Promise((resolve, reject) => {
          api.delComment(id, extra).then(() => {
            commit(SECRET.COMMENT_DEL_SUCCESS, id);
            resolve();
          }).catch(() => {
            commit(SECRET.COMMENT_DEL_FAILURE);
            reject();
          });
        });
      }
      return Promise.resolve();
    },
    [SECRET.COMMENT_DELETE_RELATIONS]({ commit }, { id }) {
      return new Promise((resolve, reject) => {
        api.deleteCommentRelations(id).then(() => {
          commit(SECRET.COMMENT_DELETE_RELATIONS, id);
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [SECRET.COMMENT_SAVE_SCROLL](state, { scroll, id }) {
      state.scrolls[id] = scroll || 0;
    },
    [SECRET.COMMENT_DEL_REQUEST](state) {
      state.lock = true;
    },
    [SECRET.COMMENT_DEL_SUCCESS](state, id) {
      /* 更新除了帖子详情页的评论列表 */
      store.commit(`secret/comment/filter/${SECRET.COMMENT_DEL_SUCCESS}`, id);
      /* 更新帖子详情页评论列表 */
      store.commit(`secret/comment/post/${SECRET.COMMENT_DEL_SUCCESS}`, id);
      state.lock = false;
    },
    [SECRET.COMMENT_DEL_FAILURE](state) {
      state.lock = false;
    },
    [SECRET.COMMENT_DELETE_RELATIONS](state, id) {
      state.list = state.list.filter(c => c.id !== id);
    },
  },
};
